import { Component, input } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';

@Component({
  selector: 'app-nav-bar-template',
  template: `
    <p-menubar class="menu-bar">
      <ng-template pTemplate="start">
        <a id="emr-nav-text" [href]="logoLink()" target="_blank">
          @if (logoImageSrc()) {
            <img [src]="logoImageSrc()" height="40" />
          }
        </a>
      </ng-template>
      <ng-template pTemplate="end">
        <ng-content></ng-content>
      </ng-template>
    </p-menubar>
  `,
  styles: [`
    .menu-bar {
      --p-menubar-border-radius: 0;
    }
  `],
  standalone: true,
  imports: [MenubarModule],
})
export class NavBarTemplateComponent {
  logoLink = input<string>();
  logoImageSrc = input<string>();
}
